import { render, staticRenderFns } from "./premium-select-code.vue?vue&type=template&id=c9da6628&scoped=true&"
import script from "./premium-select-code.vue?vue&type=script&lang=js&"
export * from "./premium-select-code.vue?vue&type=script&lang=js&"
import style0 from "./premium-select-code.vue?vue&type=style&index=0&id=c9da6628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9da6628",
  null
  
)

export default component.exports